// Action Types
export const FETCH_DOCUMENTS_REQUEST = "FETCH_DOCUMENTS_REQUEST";
export const FETCH_DOCUMENTS_SUCCESS = "FETCH_DOCUMENTS_SUCCESS";
export const FETCH_DOCUMENTS_FAILURE = "FETCH_DOCUMENTS_FAILURE";

// Action Creators
export const fetchDocumentRequest = (ticker) => {
return (dispatch) => {
  dispatch({
    type: FETCH_DOCUMENTS_REQUEST,
    payload: ticker,
  });
};
};
export const fetchDocumentSuccess = (docs) => ({
  type: FETCH_DOCUMENTS_SUCCESS,
  payload: docs,
});
export const fetchDocumentFailure = (error) => ({
  type: FETCH_DOCUMENTS_FAILURE,
  payload: error,
});
